import { baseApiAddresses } from './urls';
import { getToken } from './token';

export function hostReachable() {
  // Handle IE and more capable browsers
  const xhr = new (window.ActiveXObject || XMLHttpRequest)('Microsoft.XMLHTTP');

  // Open new request as a HEAD to the root hostname with a random param to bust the cache
  xhr.open('HEAD', `${window.location.origin}/?rand=${Math.floor((1 + Math.random()) * 0x10000)}`, false);

  // Issue request and handle response
  try {
    xhr.send();
    return (xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304 || xhr.status === 404));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
}

export function apiReachable() {
  // Handle IE and more capable browsers
  const xhr = new (window.ActiveXObject || XMLHttpRequest)('Microsoft.XMLHTTP');

  // Open new request as a HEAD to the root hostname with a random param to bust the cache
  xhr.open('HEAD', `${baseApiAddresses[process.env.HOTELMEISTER_ENV]}echo/keepAlive?rand=${Math.floor((1 + Math.random()) * 0x10000)}`, false);

  // Issue request and handle response
  try {
    xhr.send();
    return (xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304 || xhr.status === 401));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
}

let offlineUpdater = null;

export function updateOfflineStatus() {
  if (!hostReachable()) {
    window.hmOffline = true;
  } else if (!apiReachable()) {
    window.hmOffline = true;
  } else if (!navigator.onLine) {
    window.hmOffline = true;
  } else {
    window.hmOffline = false;
  }

  if (window.hmOffline && offlineUpdater === null) {
    offlineUpdater = setInterval(updateOfflineStatus, 15 * 1000);
    if (typeof window.onHmOffline === 'function') {
      window.onHmOffline();
    }
  } else if (!window.hmOffline) {
    clearInterval(offlineUpdater);
    offlineUpdater = null;
    if (typeof window.onHmOnline === 'function') {
      window.onHmOnline();
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/util/offline.js